import {PayloadAction, createSlice} from '@reduxjs/toolkit'
import {
  EstablishementState,
  FetchEstablishementsResponse,
  FetchEstablishementByIdResponse,
  FetchAllEstablishementsResponse,
} from './types'
import {
  fetchEstablishementById,
  fetchEstablishements,
  createEstablishement,
  updateEstablishement,
  deleteEstablishement,
  suspendEstablishement,
  activateEstablishement,
  fetchAllEstablishements,
} from './service'
import {ResponseError} from '../commonTypes'

const initialState: EstablishementState = {
  establishementForEdit: null,
  establishements: [],
  total: 0,
  totalPages: 0,
  listLoading: false,
  actionLoading: false,
  error: null,
}
const establishementSlice = createSlice({
  name: 'establishement',
  initialState,
  reducers: {
    resetEstablishements: (state: EstablishementState) => {
      state.establishements = []
      state.total = 0
      state.totalPages = 0
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchEstablishements.pending, (state: EstablishementState) => {
      state.listLoading = true
      state.error = null
    })
    builder.addCase(
      fetchEstablishements.rejected,
      (state: EstablishementState, action: PayloadAction<any>) => {
        const {error} = action.payload
        state.error = error
        state.listLoading = false
      }
    )
    builder.addCase(
      fetchEstablishements.fulfilled,
      (state: EstablishementState, action: PayloadAction<FetchEstablishementsResponse>) => {
        state.listLoading = false
        state.error = null
        const {establishements, total, totalPages} = action.payload
        state.establishements = establishements
        state.total = total
        state.totalPages = totalPages
      }
    )

    builder.addCase(fetchAllEstablishements.pending, (state: EstablishementState) => {
      state.listLoading = true
      state.error = null
    })
    builder.addCase(
      fetchAllEstablishements.rejected,
      (state: EstablishementState, action: PayloadAction<any>) => {
        const {error} = action.payload
        state.error = error
        state.listLoading = false
      }
    )
    builder.addCase(
      fetchAllEstablishements.fulfilled,
      (state: EstablishementState, action: PayloadAction<FetchAllEstablishementsResponse>) => {
        state.listLoading = false
        state.error = null
        const {establishements} = action.payload
        state.establishements = establishements
      }
    )

    builder.addCase(fetchEstablishementById.pending, (state: EstablishementState) => {
      state.listLoading = true
      state.error = null
    })
    builder.addCase(
      fetchEstablishementById.rejected,
      (state: EstablishementState, action: PayloadAction<any>) => {
        const {error} = action.payload
        state.error = error
        state.listLoading = false
      }
    )
    builder.addCase(
      fetchEstablishementById.fulfilled,
      (state: EstablishementState, action: PayloadAction<FetchEstablishementByIdResponse>) => {
        state.establishementForEdit = action.payload.establishement
        state.listLoading = false
        state.error = null
        state.establishementForEdit = action.payload.establishement
      }
    )

    builder.addCase(createEstablishement.pending, (state: EstablishementState) => {
      state.actionLoading = true
      state.error = null
    })
    builder.addCase(
      createEstablishement.rejected,
      (state: EstablishementState, action: PayloadAction<any>) => {
        const {error} = action.payload
        state.error = error
        state.actionLoading = false
      }
    )
    builder.addCase(
      createEstablishement.fulfilled,
      (state: EstablishementState, action: PayloadAction<FetchEstablishementByIdResponse>) => {
        state.establishementForEdit = action.payload.establishement
        state.actionLoading = false
        state.error = null
      }
    )

    builder.addCase(updateEstablishement.pending, (state: EstablishementState) => {
      state.actionLoading = true
      state.error = null
    })
    builder.addCase(
      updateEstablishement.rejected,
      (state: EstablishementState, action: PayloadAction<any>) => {
        const {error} = action.payload
        state.error = error
        state.actionLoading = false
      }
    )
    builder.addCase(
      updateEstablishement.fulfilled,
      (state: EstablishementState, action: PayloadAction<FetchEstablishementByIdResponse>) => {
        state.establishementForEdit = action.payload.establishement
        state.actionLoading = false
        state.error = null
      }
    )

    builder.addCase(deleteEstablishement.pending, (state: EstablishementState) => {
      state.actionLoading = true
      state.error = null
    })
    builder.addCase(
      deleteEstablishement.rejected,
      (state: EstablishementState, action: PayloadAction<any>) => {
        const {error} = action.payload
        state.error = error
        state.actionLoading = false
      }
    )
    builder.addCase(
      deleteEstablishement.fulfilled,
      (state: EstablishementState, action: PayloadAction<FetchEstablishementByIdResponse>) => {
        state.establishementForEdit = action.payload.establishement
        state.actionLoading = false
        state.error = null
      }
    )

    builder.addCase(suspendEstablishement.pending, (state: EstablishementState) => {
      state.actionLoading = true
      state.error = null
    })
    builder.addCase(
      suspendEstablishement.rejected,
      (state: EstablishementState, action: PayloadAction<any>) => {
        const {error} = action.payload
        state.error = error
        state.actionLoading = false
      }
    )
    builder.addCase(
      suspendEstablishement.fulfilled,
      (state: EstablishementState, action: PayloadAction<FetchEstablishementByIdResponse>) => {
        state.establishementForEdit = action.payload.establishement
        state.actionLoading = false
        state.error = null
      }
    )

    builder.addCase(activateEstablishement.pending, (state: EstablishementState) => {
      state.actionLoading = true
      state.error = null
    })
    builder.addCase(
      activateEstablishement.rejected,
      (state: EstablishementState, action: PayloadAction<any>) => {
        const {error} = action.payload
        state.error = error
        state.actionLoading = false
      }
    )
    builder.addCase(
      activateEstablishement.fulfilled,
      (state: EstablishementState, action: PayloadAction<FetchEstablishementByIdResponse>) => {
        state.establishementForEdit = action.payload.establishement
        state.actionLoading = false
        state.error = null
      }
    )
  },
})

export default establishementSlice.reducer
export const actions = establishementSlice.actions
